import { DataTableColumnHeader } from 'common/data-table-column-header';
import { linkCell } from 'utils/cell-formatter';
import { formatISODate } from 'utils/formatDate';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/admin/wards' }),
  },
  {
    accessorKey: 'name',
    header: 'Name',
  },

  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    meta: { className: 'text-right' },
    cell: ({ getValue }) => formatISODate(getValue()),
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    meta: { className: 'text-right' },
    cell: ({ getValue }) => formatISODate(getValue()),
  },
];
